import { createFileRoute } from "@tanstack/react-router";
import CarDetail from "@/pages/CarDetailV3";
import { loadListingWithRedirect, listingHead } from "@/lib/seo/listing-seo";

export const Route = createFileRoute("/listing/$slug/")({
  loader: ({ params }) => loadListingWithRedirect(params.slug, "ro"),
  head: ({ loaderData, params }) => listingHead(loaderData ?? null, params.slug, "ro"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="surface-light min-h-screen"><CarDetail /></div>
  );
}
